import { client as apiTalkClient } from '../openapi-clients-generated/talk/client.gen';
import { configureZynoOpenApiClient } from './helpers';

/**
 * Client setup for the standalone signup app (src/embedded/signup).
 *
 * Deliberately configures no headers at all. A standalone prospect only touches `/public/*` and has
 * no session, tenant, or JWT; the order id in the URL is the only capability. Authenticated MSP draft
 * creation is available only when the wizard is mounted inside the full SPA, whose normal client
 * configuration supplies verified session and tenant headers. That means none of the full app's per-request header machinery
 * (`openapi-clients/shared.ts`: Authorization, x-zs-tid, masquerade, timezone, SSE conn id) applies,
 * and pulling it in would drag Auth / MobileBridge / SSEService — and through them `@/global` — into
 * a bundle that must stay lean. See `src/embedded/signup/bundle-isolation.spec.ts`.
 *
 * Talk alone serves every endpoint signup touches. The auth client used to be configured here for
 * the MSP name lookup; the order responses carry `mspName` now, so this surface no longer ships a
 * second generated client at all. The shared `onError` policy still applies, so failures are
 * reported to Sentry with trace context.
 *
 * The SPA never calls this setup function — when the same wizard components are mounted inside the full app, the
 * clients have already been configured by `configureApiClients()` with real session headers, and the
 * public endpoints simply ignore them.
 */
export function configureSignupApiClients() {
    apiTalkClient.setConfig({
        baseUrl: import.meta.env.VITE_APP_TALK_API_URL
    });

    configureZynoOpenApiClient('signup-talk', apiTalkClient);
}
